import { useEffect, useState } from 'react';
import { post } from '../Auths/AuthToken';
import ReactDatePicker from 'react-datepicker';
import { DEFAULT_DATE_FORMATE } from '../../constents';
import { format, parse } from 'date-fns';
import inputMask from '../../Utilities/MaskInput';
import Select from 'react-select';
import setUiMessage from '../../Utilities/Tostify';
import { setRenderFormData } from '../../redux/slices/Notes/counsellingNoteSlice';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../Button';

function DemographicsPopup({ handleClose, patientId, handleReload }) {
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);

  const [appDatePickerIsOpen, setAppDatePickerIsOpen] = useState(false);
  const [allData, setAllData] = useState({});

  const [patDemoFname, setPatDemoFname] = useState('');
  const [patDemoMname, setPatDemoMname] = useState('');
  const [patDemoLname, setPatDemoLname] = useState('');
  const [dobDate, setDobDate] = useState(null);
  const [patDemoGender, setPatDemoGender] = useState('');
  const [patDemoRace, setPatDemoRace] = useState([]);
  const [patDemoRaceGroup, setPatDemoRaceGroup] = useState([]);
  const [patDemoEthincity, setPatDemoEthincity] = useState([]);
  const [patDemoEthincityGroup, setPatDemoEthincityGroup] = useState([]);
  const [patDemoHomePhone, setPatDemoHomePhone] = useState('');
  const [patDemoMobilePhone, setPatDemoMobilePhone] = useState('');
  const [patDemoEmail, setPatDemoEmail] = useState('');
  const [patDemoAddrOne, setPatDemoAddrOne] = useState('');
  const [patDemoAddrTwo, setPatDemoAddrTwo] = useState('');
  const [patDemoCity, setPatDemoCity] = useState('');
  const [patDemoState, setPatDemoState] = useState('');
  const [patDemoZip, setPatDemoZip] = useState('');
  const [patDemoCountry, setPatDemoCountry] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/patient/progressNote/patDemographics',
          {
            patientId: patientId,
          }
        );
        if (response.status === 200) {
          setAllData(response?.data);
          setPatDemoFname(response?.data?.first_name);
          setPatDemoMname(response?.data?.middle_name);
          setPatDemoLname(response?.data?.last_name);

          let dob = response?.data?.dob || null;
          if (dob) {
            setDobDate(parse(dob, 'MM-dd-yyyy', new Date()));
          } else {
            setDobDate(dob);
          }
          setPatDemoGender(response?.data?.sex);

          const selectedRace = response?.data?.dropDownRace?.filter((o) =>
            response?.data?.stats_race?.includes(o.value)
          );
          setPatDemoRace(selectedRace);

          const selectedRaceGrp = response?.data?.dropDownRaceGroup?.filter(
            (o) => response?.data?.stats_race_group?.includes(o.value)
          );
          setPatDemoRaceGroup(selectedRaceGrp);

          const selectedEthincity = response?.data?.dropDownEthnicity?.filter(
            (o) => response?.data?.stats_ethincity?.includes(o.value)
          );
          setPatDemoEthincity(selectedEthincity);

          const selectedEthincityGroup =
            response?.data?.dropDownEthnicityGroup?.filter((o) =>
              response?.data?.stats_ethincity_group?.includes(o.value)
            );
          setPatDemoEthincityGroup(selectedEthincityGroup);

          setPatDemoHomePhone(response?.data?.home_phone || '');
          setPatDemoMobilePhone(response?.data?.mobile || '');
          setPatDemoEmail(response?.data?.email || '');
          setPatDemoAddrOne(response?.data?.address || '');
          setPatDemoAddrTwo(response?.data?.correspondence_address || '');
          setPatDemoCity(response?.data?.city || '');
          setPatDemoState(response?.data?.state || '');
          setPatDemoZip(response?.data?.zip || '');
          setPatDemoCountry(response?.data?.country || '');
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [patientId]);

  const handleDemographicsSave = async () => {
    try {
      const response = await post('api/patient/progressNote/saveDemographics', {
        patientId: patientId,
        PatDemoFname: patDemoFname,
        PatDemoMname: patDemoMname,
        PatDemoLname: patDemoLname,
        patDemoDob: format(dobDate, 'MM-dd-yyyy'),
        PatDemoGender: patDemoGender,
        PatDemoStatsRace: patDemoRace
          ? patDemoRace?.map((obj) => obj.value)
          : '',
        PatDemoStatsRaceGroup: patDemoRaceGroup
          ? patDemoRaceGroup?.map((obj) => obj.value)
          : '',
        PatDemoStatsEthincity: patDemoEthincity
          ? patDemoEthincity?.map((obj) => obj.value)
          : '',
        PatDemoStatsEthincityGroup: patDemoEthincityGroup
          ? patDemoEthincityGroup?.map((obj) => obj.value)
          : '',
        PatDemoHomePhone: patDemoHomePhone,
        PatDemoMobile: patDemoMobilePhone,
        PatDemoEmail: patDemoEmail,
        PatDemoAddress1: patDemoAddrOne,
        PatDemoAddress2: patDemoAddrTwo,
        PatDemoState: patDemoState,
        PatDemoCity: patDemoCity,
        PatDemoZip: patDemoZip,
        PatDemoCountry: patDemoCountry,
        staffUserId: user.id,
      });
      if (response.status === 200) {
        handleClose();
        handleReload('demo');

        dispatch(
          setRenderFormData({
            data: { demographics: response.data.demographics },
            type: 'demo',
          })
        );
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  function openDatePicker() {
    setAppDatePickerIsOpen(!appDatePickerIsOpen);
  }

  function handleDateSelect(dateEvent) {
    setAppDatePickerIsOpen(!appDatePickerIsOpen);
  }

  return (
    <div className="modalBackground">
      <div className="main-contnr prgrs-demogrphcs center-popup">
        <div className="main-contnr-hdr flex-sec">
          <div className="hdr-pt-info">
            <span className="black-txt clear-right10">Demographics:</span>
            {allData?.patientName}
            <span className="red"> | </span>
            ID: {allData?.chartNo}
            <span className="red"> | </span>
            {allData?.age} yrs [{allData?.gender?.substr(0, 1).toUpperCase()}]
            <span className="red"> | </span>
            DOB:{allData?.dob}
          </div>

          <Button variant="circle" onClick={handleClose}>
            X
          </Button>
        </div>
        <div className="main-contnr-bdy gnr-dtl-bdy">
          <div className="width50">
            <div className="appt-hx-fa-rw">
              <span className="label">First Name:</span>
              <span className="value">
                <input
                  type="text"
                  className="inpt-width"
                  placeholder="First Name"
                  value={patDemoFname}
                  onChange={(e) => setPatDemoFname(e.target.value)}
                />
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">Middle Name:</span>
              <span className="value">
                <input
                  type="text"
                  className="inpt-width"
                  placeholder="Middle name"
                  name="patDemoMname"
                  value={patDemoMname}
                  onChange={(e) => setPatDemoMname(e.target.value)}
                />
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">Last Name:</span>
              <span className="value">
                <input
                  type="text"
                  className="inpt-width"
                  name="patDemoLname"
                  placeholder="Last name"
                  value={patDemoLname}
                  onChange={(e) => setPatDemoLname(e.target.value)}
                />
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">DOB:</span>
              <span className="value" style={{ display: 'flex' }}>
                <ReactDatePicker
                  selected={dobDate}
                  onChange={(date) => setDobDate(date)}
                  onClickOutside={openDatePicker}
                  open={appDatePickerIsOpen}
                  onSelect={handleDateSelect}
                  className="app-date-picker"
                  dateFormat={DEFAULT_DATE_FORMATE}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
                <img
                  width="10%"
                  src="./images/calendar-icon.png"
                  alt=""
                  onClick={openDatePicker}
                  style={{ marginLeft: '20px' }}
                />
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">Sex:</span>
              <span className="value">
                <select
                  className="book-appt-dd"
                  placeholder=""
                  value={patDemoGender}
                  onChange={(e) => setPatDemoGender(e.target.value)}
                >
                  <option value="">{''}</option>
                  {allData?.dropDownGender?.map((data, i) => (
                    <option key={i} value={data?.id}>
                      {data?.val}
                    </option>
                  ))}
                </select>
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">Race:</span>
              <span className="value">
                <Select
                  value={patDemoRace}
                  options={allData?.dropDownRace}
                  isMulti
                  onChange={(e) => setPatDemoRace(e)}
                />
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">Race Group:</span>
              <span className="value">
                <Select
                  value={patDemoRaceGroup}
                  options={allData?.dropDownRaceGroup}
                  isMulti
                  onChange={(e) => setPatDemoRaceGroup(e)}
                />
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">Ethnicity:</span>
              <span className="value">
                <Select
                  value={patDemoEthincity}
                  options={allData?.dropDownEthnicity}
                  isMulti
                  onChange={(e) => setPatDemoEthincity(e)}
                />
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">Ethnicity Group:</span>
              <span className="value">
                <Select
                  value={patDemoEthincityGroup}
                  options={allData?.dropDownEthnicityGroup}
                  isMulti
                  onChange={(e) => setPatDemoEthincityGroup(e)}
                />
              </span>
            </div>
          </div>
          <div className="width50">
            <div className="appt-hx-fa-rw">
              <span className="label">Home Phone:</span>
              <span className="value">
                <input
                  type="text"
                  className="inpt-width"
                  placeholder="(000) 000-0000"
                  value={patDemoHomePhone}
                  onChange={(e) =>
                    setPatDemoHomePhone(inputMask(e.target.value))
                  }
                  maxLength={14}
                  inputMode="numeric"
                />
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">Mobile Phone:</span>
              <span className="value">
                <input
                  type="text"
                  className="inpt-width"
                  placeholder="(000) 000-0000"
                  value={patDemoMobilePhone}
                  onChange={(e) =>
                    setPatDemoMobilePhone(inputMask(e.target.value))
                  }
                  maxLength={14}
                  inputMode="numeric"
                />
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">Email ID:</span>
              <span className="value">
                <input
                  type="text"
                  className="inpt-width"
                  placeholder="E-mail"
                  value={patDemoEmail}
                  onChange={(e) => setPatDemoEmail(e.target.value)}
                />
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">Address 1:</span>
              <span className="value">
                <input
                  type="text"
                  className="inpt-width"
                  placeholder=""
                  value={patDemoAddrOne}
                  onChange={(e) => setPatDemoAddrOne(e.target.value)}
                />
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">Address 2:</span>
              <span className="value">
                <input
                  type="text"
                  className="inpt-width"
                  placeholder=""
                  value={patDemoAddrTwo}
                  onChange={(e) => setPatDemoAddrTwo(e.target.value)}
                />
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">State:</span>
              <span className="value">
                <select
                  className="book-appt-dd"
                  data-placeholder=""
                  value={patDemoState}
                  onChange={(e) => setPatDemoState(e.target.value)}
                >
                  {allData?.dropDownState?.map((data, i) => (
                    <option key={i} value={data?.id}>
                      {data?.state_name}
                    </option>
                  ))}
                </select>
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">City:</span>
              <span className="value">
                <input
                  type="text"
                  className="inpt-width"
                  placeholder=""
                  value={patDemoCity}
                  onChange={(e) => setPatDemoCity(e.target.value)}
                />
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">Zip:</span>
              <span className="value">
                <input
                  type="text"
                  className="inpt-width"
                  placeholder=""
                  value={patDemoZip}
                  onChange={(e) => setPatDemoZip(e.target.value)}
                />
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">Country:</span>
              <span className="value">
                <select
                  className="book-appt-dd"
                  data-placeholder=""
                  value={patDemoCountry}
                  onChange={(e) => setPatDemoCountry(e.target.value)}
                >
                  {allData?.dropDownCountry?.map((data, i) => (
                    <option key={i} value={data?.id}>
                      {data?.country_name}
                    </option>
                  ))}
                </select>
              </span>
            </div>
          </div>
        </div>
        <div className="gnrl-dtl-btn-rw">
          <button className="actn-yes" onClick={handleDemographicsSave}>
            Save
          </button>
          <button className="actn-No" onClick={handleClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default DemographicsPopup;
